import plural from 'helpers/plural';

angular.module('filters').filter('membershipMakeupClassFilter', ["$filter", function($filter) {
  return function(plan) {
    var expires, makeupClasses, makeupClassesCount;
    expires = plan.expiration_date ? `expires ${$filter('date')(plan.expiration_date)}` : 'does not expire';
    makeupClassesCount = plan.makeup_class_allowances_count;
    makeupClasses = makeupClassesCount ? `${makeupClassesCount} make-up ${plural('classes', makeupClassesCount)} added previously` : 'has no existing make-up classes';
    return `${plan.label} (${expires}, ${makeupClasses})`;
  };
}]);
